module.exports = __webpack_public_path__ + "static/img/-to-do.6e6c07d0.png";